export const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    outline: "none",
    borderRadius: "5px",
    minWidth: 320,
    // bgcolor: 'white',
    // backgroundColor:"inherit",
    boxShadow: 24,
    px: 4,
    py: 2,
    opacity: 1
};

export const crossButtonStyle = {
    position: "absolute",
    top: "5px",
    right: "10px",
    cursor: "pointer"
}

export const storyModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    outline: "none",
    borderRadius: "5px",
    width: "100%",
    height: "100%",
    boxShadow: 24,
    p: 2
};

export const inputStyle = {
    padding: "5px 5px",
    // border: "none",
    outline: "none",
    bgcolor: 'background.paper',
    color: "text.primary",
    fontSize: "1.1rem",
    width: "95%",
    borderRadius: "5px",
    resize: "none"
}